export const CHECKUP_DIGITAL_ALLOWED_VINCULO = "2381322300";

export const CHECKUP_DIGITAL_ROUTE = "/programa-saude-2";

export const CHECKUP_DIGITAL_AVALIACAO_ROUTE = "/programa-saude-2/avaliacao";

export const CHECKUP_DIGITAL_PARTNER_URL = "https://app.marsaude.net/paciente/login/boas-vindas";

const INVITE_DISMISSED_KEY = "checkupDigitalOmint.inviteDismissed";

function normalizeVinculo(vinculo?: string | null): string {
  return String(vinculo ?? "").replace(/\D/g, "");
}

export function canSeeCheckupDigitalOmint(vinculo?: string | null): boolean {
  const value = normalizeVinculo(vinculo);
  if (!value) return false;
  return value === CHECKUP_DIGITAL_ALLOWED_VINCULO || value === CHECKUP_DIGITAL_ALLOWED_VINCULO.slice(0, 8);
}

export function checkupDigitalMenuItem(icon = "flask") {
  return {
    Label: "Programas de saúde 2",
    Icon: icon,
    View: CHECKUP_DIGITAL_ROUTE,
    Desktop: false,
    Description: "Realize o Check-up digital Omint e receba uma avaliação da sua saúde"
  };
}

function isProgramasDeSaudeMenu(menu) {
  const view = String(menu?.View || "").toLowerCase();
  if (view.includes(CHECKUP_DIGITAL_ROUTE)) return false;

  const label = String(menu?.Label || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim();

  if (label.includes("programas de saude") && !label.includes("2")) return true;
  return view.includes("programas-de-saude") || view.includes("/programas-saude");
}

export function withCheckupDigitalMenuItem(menus: any[] = [], vinculo?: string | null) {
  const list = Array.isArray(menus) ? [...menus] : [];
  if (!canSeeCheckupDigitalOmint(vinculo)) return list;
  if (list.some(menu => String(menu.View || "").includes(CHECKUP_DIGITAL_ROUTE))) return list;

  const programasIndex = list.findIndex(isProgramasDeSaudeMenu);
  const source = programasIndex >= 0 ? list[programasIndex] : null;
  const item = checkupDigitalMenuItem(source?.Icon || source?.Icone || "flask");

  if (programasIndex >= 0) {
    list.splice(programasIndex + 1, 0, item);
  } else {
    list.push(item);
  }

  return list;
}

export function wasCheckupInviteDismissed(): boolean {
  try {
    return sessionStorage.getItem(INVITE_DISMISSED_KEY) === "1";
  } catch {
    return false;
  }
}

export function dismissCheckupInvite(): void {
  try {
    sessionStorage.setItem(INVITE_DISMISSED_KEY, "1");
  } catch {
    // ignore
  }
}

export function clearCheckupInviteDismissed(): void {
  try {
    sessionStorage.removeItem(INVITE_DISMISSED_KEY);
  } catch {
    // ignore
  }
}

export function openCheckupDigitalPartner(url?: string | null): void {
  const target = String(url ?? "").trim();
  if (!target) return;

  let parsed: URL;
  try {
    parsed = new URL(target);
  } catch {
    return;
  }

  if (parsed.protocol !== "https:" && parsed.protocol !== "http:") return;
  globalThis.window.open(parsed.toString(), "_blank", "noopener,noreferrer");
}
